import { useRef } from "react";
import { SUPPORTED_END, SUPPORTED_START, julianDay } from "@solar/ephemeris";
import { useScene, useTimeMs } from "../store";
import { useT } from "../i18n";

const SPEEDS: [number, "s_h" | "s_d" | "s_10d" | "s_mo" | "s_yr"][] = [[1 / 24, "s_h"], [1, "s_d"], [10, "s_10d"], [30.44, "s_mo"], [365.25, "s_yr"]];
const WINDOW_YEARS = 8;
const toLocalInput = (ms: number) => new Date(ms).toISOString().slice(0, 16);

export function TimeBar() {
  const { t } = useT();
  const { playing, speed, setPlaying, setSpeed, setTimeMs } = useScene();
  const ms = useTimeMs(80);
  const anchor = useRef(ms);
  // 时间轴窗口 ±4 年；当前时间移出窗口时重新居中
  const half = (WINDOW_YEARS / 2) * 365.25 * 86400000;
  if (Math.abs(ms - anchor.current) > half) anchor.current = ms;
  const frac = (ms - (anchor.current - half)) / (2 * half);
  const iso = new Date(ms).toISOString();
  const years = Array.from({ length: WINDOW_YEARS + 1 }, (_, i) => new Date(anchor.current - half + (i / WINDOW_YEARS) * 2 * half).getUTCFullYear());
  const track = useRef<HTMLDivElement>(null);
  const setFromX = (x: number) => { const r = track.current!.getBoundingClientRect(); setTimeMs(anchor.current - half + ((x - r.left) / r.width) * 2 * half); };
  const drag = useRef(false);
  return (
    <div className="time glass">
      <div className="date">
        <input className="date-in" type="datetime-local" value={toLocalInput(ms)} min={toLocalInput(SUPPORTED_START)} max={toLocalInput(SUPPORTED_END)}
          title={t("outOfRange")}
          onChange={(e) => { const v = Date.parse(e.target.value + ":00Z"); if (Number.isFinite(v)) setTimeMs(v); }} />
        <span className="num">{iso.slice(11, 16)} {t("dateUtc")} · {t("jd")} {julianDay(new Date(ms)).toFixed(1)}</span>
      </div>
      <div className="ctl">
        <button className="ib" onClick={() => setTimeMs(ms - speed * 86400000)}>⏮</button>
        <button className="ib play" onClick={() => setPlaying(!playing)}>{playing ? "❚❚" : "▶"}</button>
        <button className="ib" onClick={() => setTimeMs(ms + speed * 86400000)}>⏭</button>
      </div>
      <div className="track" ref={track}
        onPointerDown={(e) => { drag.current = true; (e.currentTarget as HTMLElement).setPointerCapture(e.pointerId); setFromX(e.clientX); }}
        onPointerMove={(e) => drag.current && setFromX(e.clientX)} onPointerUp={() => { drag.current = false; }}>
        <div className="rail" style={{ background: `linear-gradient(90deg,rgba(108,198,255,.55) ${frac * 100}%,rgba(255,255,255,.12) ${frac * 100}%)` }} />
        {years.map((y, i) => (<span key={i}><div className="tick" style={{ left: `${(i / WINDOW_YEARS) * 100}%` }} /><div className="tl num" style={{ left: `${(i / WINDOW_YEARS) * 100}%` }}>{y}</div></span>))}
        <div className="knob" style={{ left: `${Math.min(100, Math.max(0, frac * 100))}%` }} />
      </div>
      <div className="speed">
        {SPEEDS.map(([v, k]) => (<button key={k} className={speed === v ? "on" : ""} onClick={() => setSpeed(v)}>{t(k)}</button>))}
      </div>
      <button className="btn" style={{ flex: "none", padding: "8px 14px" }} onClick={() => setTimeMs(Date.now())}>{t("backToday")}</button>
    </div>
  );
}
